import { LOCALE_ID, importProvidersFrom } from '@angular/core';

import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  AuthInterceptor,
  AuthService,
  FocusService,
  DateService,
  HotelService,
  EmailService,
  SnackbarService,
} from './app/@Services';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localHu from '@angular/common/locales/hu';

registerLocaleData(localHu);
bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      BrowserAnimationsModule,
      MatDialogModule,
      MatIconModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatFormFieldModule,
    ),
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' },
    { provide: LOCALE_ID, useValue: 'hu-HU' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    AuthService,
    FocusService,
    DateService,
    HotelService,
    EmailService,
    SnackbarService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
